module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n\n<router-outlet> </router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main